// extracted by css-extract-rspack-plugin
export default {"slot":"nXVij","debug":"vYUzj","not_found":"nPmVt","notFound":"nPmVt","banner":"bcZ_2"};